export default __webpack_public_path__ + "img/InterDisplay-Regular_d8c62aa.woff2";